var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MAX_ENTRIES = 50;
var MAX_BODY_LENGTH = 2048;
var history = [];
var getApiHistory = function () { return history; };
var addEntry = function (entry) {
    history.push(entry);
    if (history.length > MAX_ENTRIES) {
        history.shift();
    }
};
var truncate = function (str) {
    if (str.length <= MAX_BODY_LENGTH)
        return str;
    return str.slice(0, MAX_BODY_LENGTH) + "... (truncated, ".concat(str.length, " total)");
};
var extractMethod = function (resource, options) {
    if (options === null || options === void 0 ? void 0 : options.method)
        return options.method.toUpperCase();
    if (resource instanceof Request)
        return resource.method.toUpperCase();
    return 'GET';
};
var extractUrl = function (resource) {
    if (typeof resource === 'string')
        return resource;
    if (resource instanceof URL)
        return resource.toString();
    if (resource instanceof Request)
        return resource.url;
    return String(resource);
};
var extractRequestBody = function (_resource, options) {
    var body = options === null || options === void 0 ? void 0 : options.body;
    if (!body)
        return null;
    if (typeof body === 'string')
        return truncate(body);
    if (body instanceof URLSearchParams)
        return truncate(body.toString());
    if (body instanceof FormData)
        return '[FormData]';
    if (body instanceof Blob)
        return "[Blob ".concat(body.size, " bytes]");
    if (body instanceof ArrayBuffer)
        return "[ArrayBuffer ".concat(body.byteLength, " bytes]");
    return '[unknown body type]';
};
var safeReadResponseBody = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var contentType, text, length_1, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                contentType = (_b = response.headers.get('content-type')) !== null && _b !== void 0 ? _b : '';
                if (!(contentType.includes('application/json') || contentType.includes('text/'))) return [3 /*break*/, 2];
                return [4 /*yield*/, response.clone().text()];
            case 1:
                text = _c.sent();
                return [2 /*return*/, truncate(text)];
            case 2:
                length_1 = response.headers.get('content-length');
                return [2 /*return*/, "[".concat(contentType || 'binary', " ").concat(length_1 ? length_1 + ' bytes' : '', "]").trim()];
            case 3:
                _a = _c.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var installed = false;
var installFetchInterceptor = function () {
    if (installed)
        return;
    installed = true;
    var currentFetch = window.fetch;
    window.fetch = function (resource, options) { return __awaiter(void 0, void 0, void 0, function () {
        var method, url, requestBody, start, response, responseBody, _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    method = extractMethod(resource, options);
                    url = extractUrl(resource);
                    requestBody = extractRequestBody(resource, options);
                    start = performance.now();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, currentFetch.call(window, resource, options)];
                case 2:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = null;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, safeReadResponseBody(response)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    responseBody = _a;
                    addEntry({
                        timestamp: new Date().toISOString(),
                        method: method,
                        url: url,
                        status: response.status,
                        durationMs: Math.round(performance.now() - start),
                        error: null,
                        requestBody: requestBody,
                        responseBody: responseBody,
                    });
                    return [2 /*return*/, response];
                case 6:
                    err_1 = _b.sent();
                    addEntry({
                        timestamp: new Date().toISOString(),
                        method: method,
                        url: url,
                        status: null,
                        durationMs: Math.round(performance.now() - start),
                        error: err_1 instanceof Error ? err_1.message : String(err_1),
                        requestBody: requestBody,
                        responseBody: null,
                    });
                    throw err_1;
                case 7: return [2 /*return*/];
            }
        });
    }); };
};
export { getApiHistory, installFetchInterceptor };
